import getPlayfieldPosition from './playfieldPosition';
import './BossProjectile.css';

function BossProjectile({ projectile }) {
  return (
    <div
      className="boss-projectile"
      style={getPlayfieldPosition(projectile.x, projectile.y)}
      aria-hidden="true"
    />
  );
}

export default BossProjectile;
